import moment from "moment";

export default function(date: Date, format = "YYYY.MM.DD HH:mm"): string {
  return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
}
